<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="useFullAmount"
              label="Спрашивать полную сумму заказа"
              hint="Снимите, чтобы платить фиксированную сумму — так проверяют оплату на боевых реквизитах"
              persistent-hint
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="fixedAmount"
              label="Сумма вместо полной, сом"
              type="number"
              step="0.01"
              dense
              outlined
              :disabled="useFullAmount"
              :rules="useFullAmount ? [] : [rules.required]"
              hint="Учитывается, только когда снят флаг выше"
              persistent-hint
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="fixedAmountScope"
              :items="paymentAmountScopesDropDown"
              label="Где применять сумму вместо полной"
              dense
              outlined
              :disabled="useFullAmount"
              hint="Проверять оплату можно только в приложении или только на сайте"
              persistent-hint
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="ttlMinutes"
              label="Срок жизни QR и платёжной ссылки, мин"
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-alert
              v-if="!useFullAmount"
              type="warning"
              text
              dense
            >
              Гость заплатит {{ fixedAmount }} сом вместо суммы заказа — {{ scopeDescription }}.
              Не оставляйте так на бою.
            </v-alert>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'

export default {
  name: 'PaymentSettingForm',
  data: () => ({
    rules,
  }),
  computed: {
    ...mapFormHandlers('paymentSettings', [
      'useFullAmount',
      'fixedAmount',
      'fixedAmountScope',
      'ttlMinutes',
    ]),
    ...mapGetters('dictionary', ['paymentAmountScopesDropDown']),
    scopeDescription() {
      const scope = this.paymentAmountScopesDropDown.find(x => x.value === this.fixedAmountScope)

      return scope ? scope.text.toLowerCase() : 'везде'
    },
  },
  async created() {
    await this.fetch()
    await this.fetchPaymentAmountScopes()
  },
  methods: {
    ...mapActions('paymentSettings', ['update', 'fetch']),
    ...mapActions('dictionary', ['fetchPaymentAmountScopes']),
    cancel() {
      this.$router.back()
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update()
      }
    },
  },
}
</script>
